export const settings = {
    showThumbs: false,
    showArrows: false,
    showStatus: false,
    emulateTouch: true,
    autoPlay: true,
    interval: 3000,
    infiniteLoop: true,
    stopOnHover: true,
    dynamicHeight: true,
};
